
import './styles.scss'

export function NewVersion({children}){
    return(
        <div id='new-version' className="new-version">
            {children}
        </div>
    )
}